import toFixedValue from 'app/common/lib/toFixedValue'

import SimpleDate from 'app/common/classes/simple-date'

import {
  ColsGroupedDataType,
  GroupedTotalDataType,
  KlassesGroupedType,
  ReportSubsidiesGroupedData, RowGroupedData, SubsidiesGroupedSection, SubsidyGroupedSummaryType,
} from 'app/dataTypes/reports/data/common/subsidies/grouped'

import { ApiSubsidiesGrouped, ColsDataApi, GroupedDataApi, KlassesInfoApi, SummaryApi } from './data-api-grouped.type'

export type ApiResultSubsidiesGrouped = ApiSubsidiesGrouped
const dateFormatDto = 'YYYY-MM-DD' as const

export const isRestFoodData = (data: ApiResultSubsidiesGrouped): data is ApiResultSubsidiesGrouped => {
  return 'section' in data && data.section === "rest_food"
}

const convertCols = (colsData: ColsDataApi): ColsGroupedDataType => {
  const { day_cares: dayCares, klasses } = colsData
  return {
    dayCares,
    klasses,
  }
}

const convertKlassesData = (klassesApi: Record<string, KlassesInfoApi>): Array<KlassesGroupedType> => {
  return Object.entries(klassesApi).map(([title, klasses]) => ({
    title,
    sum: toFixedValue(klasses.sum),
    count: klasses.count,
    students: klasses.students,
  }))
}

const convertGroupedData = (groupedData: GroupedDataApi): GroupedTotalDataType => {
  return {
    dayCares: convertKlassesData(groupedData.day_cares),
    klasses: convertKlassesData(groupedData.klasses),
    sum: toFixedValue(groupedData.sum),
    count: groupedData.count,
    students: groupedData.students,
  }
}

const convertRows = (rowsData: Record<string, GroupedDataApi>): Array<RowGroupedData> => {
  return Object.entries(rowsData).map(([date, row]) => ({
    date: new SimpleDate(date, dateFormatDto),
    ...convertGroupedData(row),
  }))
}


const convertSummary = (summaryApi: SummaryApi): SubsidyGroupedSummaryType => {
  const {
    sum,
    count,
    klasses,
    day_cares: dayCares,
  } = summaryApi
  return {
    sum,
    count,
    klasses,
    dayCares
  }
}


export const convertResultSubsidiesGrouped = (
  apiData: ApiResultSubsidiesGrouped,
): ReportSubsidiesGroupedData => {

  if (isRestFoodData(apiData)) {
    const { document, date, cols, total, rows, summary } = apiData

    return {
      section: SubsidiesGroupedSection.RestFood,
      document,
      dateFrom: new SimpleDate(date.from, dateFormatDto),
      dateTo: new SimpleDate(date.to, dateFormatDto),
      cols: convertCols(cols),
      rows: convertRows(rows),
      total: convertGroupedData(total),
      summary: convertSummary(summary)
    }
  }

  const exhaustiveCheck: never = apiData
  return exhaustiveCheck
}
